import React, { useEffect, useContext, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper } from "@material-ui/core";
import { Title } from "App/Component/ui";
import { FormReq, RenderListReq } from "./ui";

import { FormContext, FormProvider } from "./context/FormContext";
import { FORM_RESET_STATE_WMS_RMT, getReqListById } from "./helpers";
import { WMS_FA_HELPDESK } from "App/constants";
import { defaultToastError, isNull } from "App/utils/helpers";
// import { isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function HelpDesk(props) {
  const classes = useStyles();
  const { data, menu } = props;
  return (
    <FormProvider data={data} menu={menu}>
      <div className={classes.root}>
        <Title title={"Input Help Desk"} />
        <Paper className={classes.paper}>
          <RenderContent
            classes={classes}
            data={menu === WMS_FA_HELPDESK ? data : null}
            datas={data}
          />
        </Paper>
      </div>
    </FormProvider>
  );
}

const RenderContent = ({ classes, data, datas }) => {
  const namaInputRef = useRef(null);
  const { setListDetail, setFormData, formData } = useContext(FormContext);

  useEffect(() => {
    setNewDataReqList(data?.id);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataReqList = async (id) => {
    await getListReq(id);
  };

  const getListReq = async (id) => {
    // console.log("Cek ID", id);
    if (!isNull(id)) {
      const res = await getReqListById(id);
      if (res.state) {
        setFormData(res.data);
        setListDetail(res.data.detail);
      } else {
        defaultToastError(res.message);
        setFormData(FORM_RESET_STATE_WMS_RMT);
        setListDetail([]);
      }
    }
  };

  return (
    <>
      <FormReq classes={classes} setNewDataReqList={setNewDataReqList} />
      {!isNull(formData.id) && (
        <>
          <div className="mt-2"></div>
          <RenderListReq
            classes={classes}
            setNewDataReqList={setNewDataReqList}
            namaInputRef={namaInputRef}
          />
        </>
      )}
    </>
  );
};
